import React, { useCallback } from 'react';
import { SETTING } from 'interfaces/settings';
import { useAutodialerSettings } from '../../hooks/useAutodialerSettings';

export function BooleanSettingControl({ setting }: { setting: SETTING }) {
    const { getValueForSetting, updateSetting } = useAutodialerSettings();
    const value = getValueForSetting(setting);
    const currentValue = typeof value === 'boolean' ? value : false;
    
    const onChange = useCallback((newValue: boolean) => {
        updateSetting(setting, newValue);
    }, [setting, updateSetting]);
    
    return (
        <div className="flex items-center min-h-[32px]">
            <button
                onClick={() => onChange(!currentValue)}
                className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex-shrink-0 ${
                    currentValue ? 'bg-blue-600' : 'bg-gray-200'
                }`}
            >
                <span
                    className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform duration-200 ${
                        currentValue ? 'translate-x-5' : 'translate-x-1'
                    }`}
                />
            </button>
        </div>
    );
} 